export default __webpack_public_path__ + "static/media/support-notes-logo-boomberg.62d6a7d5.svg";